import "../scss/main.scss";

(function ($) {

    $(document).ready(function () {
        theme.init()
    });

	var theme = {
		init: function () {
			this.rebuildCollectionFilters(0);
			this.searchTop();
			this.occasionSlider();
			this.collectionsSlider();
			this.opinionsSlider();
			this.appreciatedSlider();
			this.accordionDiv();
			this.similarProducts();
			this.variantsSwitcher();
			this.singleProductGalleries();
			this.showFilters();
			this.hamburger();
			this.books();
			this.typed();
			this.scrollUp();
			this.counter();
			this.teamSlider();
			this.checkFile();
			this.shopFilters();
			this.ajaxPagination();
			this.removeFilters();
			this.orderbyChange();
			this.collapseFilters();
			this.loadFiltersFromGet();
			this.cf7FileInputs();
			this.relatedPostsSlick();
			this.readmoreOnClick();

			window.addEventListener( "pageshow", ( event ) => {
				var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
				if ( historyTraversal ) {		
					setTimeout(() => {
						this.loadFiltersFromGet();
					}, 300)		  
				}
			});
		},

		relatedPostsSlick: function(){
			$('.related-posts-slick').slick({
				slidesToShow: 3,
				slidesToScroll: 1,				
				arrows: true,
				dots: true,
				responsive: [
					{
					  breakpoint: 991,
					  settings: {
						slidesToShow: 2
					  }
					},
					{
						breakpoint: 767,
						settings: {
						  slidesToShow: 1
						}
					}
				  ]
			})
		},

		readmoreOnClick: function(){
			$('.czytaj-dalej-button').click(function(e){
				$(this).parent().addClass('open');
			});
		},

		cf7FileInputs: function(){
			$(document).on('change', '.wpcf7 input[type="file"]', function(e){
				if($(this).hasClass('wpcf7-not-valid')){
					$(this).val('').addClass('empty');
				}

				if($(this).val() != ''){
					$(this).next('.remove-file').remove();
					$(this).after('<span class="remove-file">x</span>');
				}
			})

			$(document).on('click', '.remove-file', function(e){
				e.preventDefault();
				let input = $(this).prev('input[type="file"]');
				input.addClass('empty').val('');
				$(this).remove();
			})
		},

		loadFiltersFromGet: function(){
			var queryString = window.location.search;
			queryString = queryString.replace('?', '');
			if(queryString.length > 0){
				var splitted = queryString.split('&');
				var assign = {};
				splitted.forEach(function(value){
					let tmp = value.split('=');
					if(tmp.length == 2){
						let key = tmp[0];
						let values = tmp[1];						
						if(key.indexOf('filterby_') == 0){
							values = values.split(',');
						}
						assign[key] = values;
					}
				})

				if(assign.order_by){
					$('#catalog-sort').val(assign.order_by);
				}

				$.each(assign, function(key, values){
					if(key.indexOf('filterby_') == 0){
						var linkKey = key.replace('by_', '_');					
						values.forEach((value) => {
							let tmp = linkKey + '=' + value;
							$('.filters').find(`a[href*="${tmp}"]`).addClass('active').closest('.widget-area').addClass('open').find('ul').show();
						})
					}
				})

				if($('[data-products_list]').length > 0){
					this.reloadProducts(assign.pageno);
				}
				
			}
		},

		removeFilters: function(){
			$(document).on('click', '[data-remove_filter]', function(e){
				e.preventDefault();
				let href = $(this).data('remove_filter');
				console.log(href);
				let link = $('.filters').find(`a[href="${href}"]`);
				link.trigger('click');
			})
		},

		checkFile: function(){
			if ($('.wpcf7-file').val() == '') {
				$('.wpcf7-file').addClass("empty");
			}
			$(document).on('change', '.wpcf7-file', function(){
					$('.wpcf7-file').removeClass("empty");
			})
		},

		teamSlider: function(){
			$('.team-inner').slick({
				infinite: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				dots: false,
				arrows: true,
				autoplay: true,
				autoplaySpeed: 3000,
				responsive: [
					{
					  breakpoint: 1200,
					  settings: {
						slidesToShow: 3
					  }
					},
					{
						breakpoint: 991,
						settings: {
						  slidesToShow: 2
						}
					},
					{
						breakpoint: 767,
						settings: {
						  slidesToShow: 1
						}
					}
				  ]
			});			  
		},

		
		formatNumber: function (number) {
			var numberFormatted = number.toLocaleString('fr-FR');
			return numberFormatted;
		},

		counter: function(){

			var _this = this;
			$('.percent-inner').waypoint(function () {
				const element = $($(this)[0].element);	
						
				if (element.hasClass('started')) return;

				var countTo = element.attr('data-count');
				$({
					countNum: element.text()
				}).animate({
					countNum: countTo
				}, {

					duration: 3000,
					easing: 'swing',
					step: function () {
						var currentNumber = Math.floor(this.countNum);
						var numberFormatted = _this.formatNumber(currentNumber);
						element.text(numberFormatted);
					},
					start: function () {
						element.addClass('started');
					},
					complete: function(){
						var currentNumber = Math.floor(this.countNum);
						var numberFormatted = _this.formatNumber(currentNumber);
						element.text(numberFormatted);
					}
				});
			}, {
				offset: '100%'
			})


			// $('.percent-inner').each(function () {
			// 	$(this).prop('Counter',0).animate({
			// 		Counter: $(this).text()
			// 	}, {
			// 		duration: 4000,
			// 		easing: 'swing',
			// 		step: function (now) {
			// 			$(this).text(Math.ceil(now));
			// 		}
			// 	});
			// });
		},

		typed: function(){
			if($('#typed').length > 0){
				new Typed('#typed', {
					stringsElement: '#typed-strings',
					typeSpeed: 50,
					backSpeed: 50,
					startDelay: 0,
					showCursor: false,
					loop: true,
					loopCount: Infinity
				});
			}
		},

		books: function(){
			var _this = this;
			var wrapper = $('.flipbook');
			if($('.flipbook').length > 0){
				wrapper.turn({
					page:2,
					width:wrapper.width(),				
					height:490,	
					gradients: false,
					autoCenter: false,
					next:true,
					when: {
						turned: function(event, page, pageObj) {	
							var newPage = _this.calculatePage(page);
							$('.occasions-inner').slick('slickGoTo', newPage);
						}
					}	
				});
			}

			_this.showHideBookNav(2, wrapper);

			wrapper.bind('turning', function(e, page) {
				_this.showHideBookNav(page, wrapper);
				if(page == 1){
					e.preventDefault()
				}
			});

			wrapper.bind('start', function(e, data){
				if(data.next == 1) {
					e.preventDefault();
				}
			});
			$("#prev").click(function(e){
				e.preventDefault();
				wrapper.turn("previous");
			});
			
			$("#next").click(function(e){
				e.preventDefault();
				wrapper.turn("next");
			});
		},

		showHideBookNav: function(page, wrapper){
			var book = wrapper.closest('.book');
			book.removeClass('first-page-visible');
			book.removeClass('last-page-visible');
			var newPage = this.calculatePage(page);

			var totalPages = wrapper.data('pages_count');
			if(newPage == totalPages - 1){
				book.addClass('last-page-visible');
			}				
			if(newPage == 0){
				book.addClass('first-page-visible');
			}

		},

		calculatePage: function(page){

			if(page%2==0){
				var newPage = page / 2 - 1;
			}
			else{
				var newPage = (page + 1)/2 - 2;
			}

			return Math.max(newPage, 0);
		},

		scrollUp: function(){
			$(window).scroll(function() {    
				var scroll = $(window).scrollTop();
				if (scroll >= 200) {
					$(".back-to-top").addClass("visible");
				} else {
					$(".back-to-top").removeClass("visible");
				}
			});
			$(".back-to-top").click(function() {
				$("html, body").animate({ scrollTop: 0 }, "slow");
				return false;
			});
		},

		hamburger: function(){
			$('.hamburger').click( function() {
				$(".hamburger").toggleClass("open");
				$(".menu-header-container").toggleClass("open");
			} );
		},

		arrayUnique: function(array){
			let newArray = $.grep(array, function(el, index) {
				return index === $.inArray(el, array);
			});
			return newArray;
		},

		rebuildCollectionFilters: function(page){
			var filtersContainer = $('.occasions .occasions-bottom-inner .filters-inner');
			let filters = [];
			$('.collections-products [data-attribute_price]').each(function(){
				if($(this).data('container_class') == 'product-page-' + page){
					let price = $(this).data('attribute_price');
					filters.push(price);
				}
			})

			filters.sort();

			filters = this.arrayUnique(filters);
			var html = "";
			filters.forEach((elem) => {
				html += `<span data-collections_filter="${elem}">${elem}</span>`;
			})
			filtersContainer.html(html);
		},

		showFilters: function(){
			// $('.filters-inner').each(function(){
			// 	var form = $(this).find('form');
			// 	var select = $(this).find('select');
			// 	if(select.length > 0 && form.length > 0){
			// 		var html = "";
			// 		select.find('option').each(function(){
			// 			let value = $(this).val();
			// 			if(value){
			// 				let label = $(this).text();
			// 				let className = $(this).is(":selected") ? "active" : "";
			// 				html += `<span class="${className}" data-filter_change="${value}">${label}</span>`;
			// 			}
			// 		});
			// 		form.after(html);
			// 	}
			// })

			// $(document).on('click', '[data-filter_change]', function(e){
			// 	e.preventDefault();
			// 	let value = $(this).data('filter_change');
			// 	var select = $(this).closest('.filter-widget').find('select');
			// 	var option = select.find(`option[value="${value}"]`);
			// 	if(option.is(":selected")){
			// 		option.prop("selected", false);
			// 	}
			// 	else{
			// 		option.prop("selected", true);
			// 	}
			// 	select.trigger('change').closest('form').submit();		
			// })
		},

		singleProductGalleries: function(){
			$('.variant-gallery').each(function(){
				var element = $(this);
				element.slick({
					slidesToScroll:1,
					slidesToShow: 1,
					arrows: true,
					dots: false, 
					adaptiveHeight: true
				})	
			})

			$(document).on('click', '[data-slick_goto]', function(e){
				e.preventDefault();
				let index = $(this).data('slick_goto');
				$(this).closest('.variant-gallery-controls').prev('.variant-gallery').slick('slickGoTo', index);
			})
		},

		variantsSwitcher: function(){
			$(document).on('click', '[data-switch_variant]', function(e){
				e.preventDefault();
				let variantId = $(this).data('switch_variant');
				$(this).closest('.variants-inner').find('[data-switch_variant]').removeClass('active');
				$(this).addClass('active');
				$('.variant-container').removeClass('variant-active');
				$('.variant-id-' + variantId).addClass('variant-active');

				$('.variant-id-' + variantId).find('.slick-initialized').slick('refresh')
			})
		},

		similarProducts: function(){
			$('.similar-products-inner').slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: true,
				arrows: true,
				responsive: [
					{
						breakpoint: 991,
						settings: {
						  slidesToShow: 2,
						  dots: false,
						  slidesToScroll: 2
						}
					}
				  ]
			  });			  
		},

		accordionDiv: function(){
			$( function() {
				$( "#accordion" ).accordion({
				  heightStyle: "content",
				  header: '> div.single-question > h3',
				  active: false,
				  collapsible: true,
				});
			  } );
		},

		searchTop: function(){
			$('.search-box img, .mobile-close').click( function() {
				$(".header-search-form").toggleClass("visible");
			} );
		},
		appreciatedSlider: function(){
			$('.appreciated-us-inner').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				arrows: true
			  });			  
		},
		occasionSlider: function(){
			var carousel = $('.occasions-inner').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				arrows: true,
				responsive: [
					{
					  breakpoint: 767,
					  settings: {
						arrows: false
					  }
					}
				  ]
			});		
			
			carousel.on('afterChange', (event, slick, currentSlide) => {
				this.showCollectionsPage(currentSlide)
			})
		},

		showCollectionsPage: function(page){
			var slickCarousel = $('.collections-products')
			slickCarousel.slick('slickUnfilter');
			slickCarousel.slick('slickFilter', function(element){
				if($(this).data('container_class') == 'product-page-' + page){
					return true;
				}
				return false;
			})
			this.rebuildCollectionFilters(page);

			$('[data-header_class]').hide();
			$('[data-header_class="header-page-'+page+'"]').show()
		},

		collectionsSlider: function(){

			var slickCarousel = $('.collections-products').slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 3,
				dots: true,
				arrows: true,
				appendDots: $(".paging"),
				customPaging: function(slick,index) {
					return '<a>' + (index + 1) + '</a>';
				},
				nextArrow: $('.next-collections'),
				prevArrow: $('.prev-collections'),
				responsive: [
					{
					  breakpoint: 991,
					  settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					  }
					}
				  ]
			});	

			this.showCollectionsPage(0);

			$(document).on('click', '[data-collections_filter]', function(e){
				slickCarousel.slick('slickUnfilter')
				e.preventDefault();
				$(this).closest('.filters-inner').find('span').not($(this)).removeClass('active');
				$(this).toggleClass('active');
				var activeFilters = $('[data-collections_filter].active');
				var filters = [];
				activeFilters.each(function(){
					filters.push($(this).data('collections_filter'));
				})

				let pageNumber = $('.occasions-inner').slick('slickCurrentSlide');				

				slickCarousel.slick('slickUnfilter')
				slickCarousel.slick('slickFilter', function(element){
					let attr = $(this).data('attribute_price').toString();
					let page = $(this).data('container_class');
					if(page == 'product-page-' + pageNumber){
						if(filters.length > 0){
							if($.inArray(attr, filters) !== -1 ){
								return true;
							}
							return false;
						}
						return true;
					}
					return false;
				})
			})
			  
			  
		},


		opinionsSlider: function(){
			$('.opinions-list').slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: true,
				arrows: true,
				responsive: [
					{
					  breakpoint: 1600,
					  settings: {
						slidesToShow: 3
					  }
					},
					{
						breakpoint: 1100,
						settings: {
						  slidesToShow: 2
						}
					},
					{
						breakpoint: 767,
						settings: {
						  slidesToShow: 1
						}
					}
				  ]
			});			  
		},

		shopFilters: function(){
			var _this = this;
			$(document).on('click', '[data-shop_filters] a, .reset-filters', function(e){
				e.preventDefault();
				if($(this).hasClass('reset-filters')){
					$('[data-shop_filters] a').removeClass('active');
					$('.filter-collapsed.open').removeClass('open').find('.woocommerce-widget-layered-nav-list').slideUp();
					_this.reloadProducts();		
				}
				else{
					//$(this).closest('.widget-area').find('a').not($(this)).removeClass('active');
					$(this).toggleClass('active');
					_this.reloadProducts();		
				}
			})

			$(document).on('click', '[data-toggle_filters]', function(e){				
				e.preventDefault();
				var elem = $('.sets-left .filters');
				if(elem.is(':visible')) {
					elem.slideUp();
					$(this).html($(this).data('open-text'));
				}
				else {
					elem.slideDown();
					$(this).html($(this).data('close-text'));
				}
			})
		},

		reloadProducts: function(page){

			if(!page) page = 1

			var wrapper = $('.block-reloading');
			var _this = this;
			var args = this.buildProductsFilterArgs(page);

			this.createFiltersUrl(args)

			this.xhr = $.ajax({
                url: scripts_vars.ajaxurl,
                dataType: 'json',
                method: 'post',
                data: args,
                beforeSend: function(){
                    if(_this.xhr){
                        _this.xhr.abort();
                    }
					wrapper.block({ message: '' });
                },
                success: function(response){
					$('[data-products_list]').html(response.products);
					$("html, body").animate({ scrollTop: $('.sets-right').offset().top }, 0);
					wrapper.unblock();
				},
				error: function(){
					wrapper.unblock();
				}
			});
		},

		createFiltersUrl: function(args){
			var url = "?";
			var linkArgs = {};
			linkArgs.pageno = args.pageno;
			linkArgs.orderby = args.orderby;

			$.each(args.filters, function(name, values){
				url += '&filterby_'+name+'='+values.join(',');
			})

			if(args.pageno){
				url += '&pageno='+args.pageno;
			}

			if(args.orderby){
				url += '&order_by='+args.orderby;
			}
			
			history.replaceState({}, url, url);

		},

		buildProductsFilterArgs: function(page){
			var args = {
                action: 'get_ajax_products',
				filters: {},
				pageno: page,
				orderby: null
            };

			var orderby = $('#catalog-sort').val();
			if(orderby) args.orderby = orderby;

			var html = "";
			var show = false;

			var counter = 0;

			$('.filters a.active').each(function(){
				counter ++;
				show = true;
				var label = $(this).text();
				var href = $(this).attr('href');
				html += `<span>${label} <button class="close-button" data-remove_filter="${href}"></button></span>`;


				let url = $(this).attr('href');
				let tmp = url.split('filter_');
				if(tmp[1]){
					let tmp2 = tmp[1].split('=');
					if(tmp2.length == 2){
						let name = tmp2[0];
						let value = tmp2[1];
						if(!args.filters[name]) args.filters[name] = [];
						args.filters[name].push(value);
					}
				}
			})

			

			if(show){
				$('.active-filters').addClass('visible');
			}
			else{
				$('.active-filters').removeClass('visible');
			}

			if(counter > 0){
				html = '<a href="#" class="reset-filters">'+scripts_vars.i18n.clearFilters+'</a>' + html;
				$('.filters-count').html(`(${counter})`)
			}
			else{
				$('.filters-count').html(``)
			}

			$('.active-filters .filters-inner').html(html);

			

			return args;
		},

		orderbyChange: function(){
			$(document).on('change', '#catalog-sort', (e) => {
				e.preventDefault();
				this.reloadProducts(1);
			})
		},

		ajaxPagination: function(){
			var _this = this;
			$(document).on('click', '[data-products_list] .woocommerce-pagination a', function(e){
				e.preventDefault();
				var page = 1;
				let href = $(this).attr('href');
				let split1 = href.split('/page/');
				if(split1.length == 2){					
					page = parseInt(split1[1]);					
				}
				else{
					let split2 = href.split('paged=');
					if(split2.length == 2){
						page = parseInt(split2[1]);
					}
				}
				_this.reloadProducts(page);
			})
		},

		collapseFilters: function(){
			$('.widget-area.filter-collapsed').first().removeClass('filter-collapsed');

			$(document).on('click', '.filter-collapsed .widget-title', function(e){
				e.preventDefault();
				var wrapper = $(this).closest('.filter-collapsed');
				wrapper.toggleClass('open');
				if(wrapper.hasClass('open')){
					wrapper.find('.woocommerce-widget-layered-nav-list').slideDown();
				}
				else{
					wrapper.find('.woocommerce-widget-layered-nav-list').slideUp();
				}
			})
		}

    }
})(jQuery)